import { memberId } from '@trello/session-cookie';
import { useBoardStarsQuery } from './BoardStarsQuery.generated';

export class MissingBoardStarsDataError extends Error {
  constructor() {
    const message = 'Failed to load data from useBoardStarsQuery';
    super(message);
    this.name = 'MissingBoardStarsDataError';
  }
}

interface UseBoardStarsProps {
  skip?: boolean;
}

export const useBoardStars = (props?: UseBoardStarsProps) => {
  const skip = !!props?.skip;

  // eslint-disable-next-line @trello/no-apollo-refetch
  const { data, error, loading, refetch } = useBoardStarsQuery({
    variables: {
      memberId: memberId || '',
    },
    skip,
  });

  /*
    There is a known issue where our Apollo/GraphQL implementation returns
    undefined for data, loading, and error. We create a specific instance
    of error in these cases, so that we can report it as a non-error
    operational event.
  */
  const invalidDataError =
    !loading && !error && !data?.member && !skip
      ? new MissingBoardStarsDataError()
      : undefined;

  return { data, error: error || invalidDataError, loading, refetch };
};
